<template>
  <div class="c-content-one-column">
    <div class="column">
      <sc-placeholder name="jss-content-one-column" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
/* This layout component is really only needed for the /cis test pages
 * because they don't have all of the layout HTML added by specific
 * templates and the Partial Designs */
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-One-Column',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    rendering: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.c-content-one-column {
  @include margin-y(2rem);
  @include padding-x-thin;
}
</style>
